import { NgModule } from '@angular/core';

import { NgxEchartsModule } from 'ngx-echarts';

import * as echarts from 'echarts/core';

import { BarChart } from 'echarts/charts';
echarts.use([BarChart]);

import {
  TooltipComponent,
  LegendComponent,
  AxisPointerComponent,
  GridComponent,
} from 'echarts/components';
echarts.use([
  TooltipComponent,
  LegendComponent,
  AxisPointerComponent,
  GridComponent,
]);

import { SVGRenderer } from 'echarts/renderers';
echarts.use([SVGRenderer]);

@NgModule({
  imports: [
    NgxEchartsModule.forRoot({
      echarts,
    }),
  ],
  exports: [NgxEchartsModule],
})
export class ChartModule {}
